export interface CssVarsTheme {
   brand: string;
   class: string;

   parent: string;
   title: string;
   name: string;
   contactus: string;
   terms: string;
   favIcon: string;
   logo: string;
   svgLogo: string;
   logoUrl: string;

   isdark?: boolean;

   primary: string;
   accent: string;
   warn: string;

   header: string;
   secondary: string;
   "activity-color": string;
   "activity-contrast": string;

   success: string;
   alert: string;
   notification: string;
}

export const defaults: CssVarsTheme = {
   brand: 'DEFAULT',
   parent: 'http://www.radiantdelivers.com',
   class: 'radiant',
   title: 'Radiant',
   name: 'Radiant Global Logistics',
   contactus: 'https://rgl.radiantdelivers.com/contact-us',
   terms: 'http://www.radiantdelivers.com/terms',
   favIcon: 'https://rgl-static-cdn.s3.amazonaws.com/favicons/radiant-favicon.ico',
   logo: 'https://rgl-static-cdn.s3.amazonaws.com/logos/png-white/radiant-logo.png',
   svgLogo: 'https://rgl-static-cdn.s3.amazonaws.com/logos/svg/radiant-logo.svg',
   logoUrl: 'url(https://rgl-static-cdn.s3.amazonaws.com/logos/png-white/radiant-logo.png)',

   isdark: false,

   primary: '#151450',
   accent: '#3496d0',
   warn: '#F44336',

   header: '#b71c1c',
   secondary: '#F5F5F5',
   "activity-color": '#F5F5F5',
   "activity-contrast": 'rgba(0, 0, 0, 0.87)',

   success: '#4CAF50',
   alert: '#ffe0b3',
   notification: '#F5F5F5',
};
